export default "__VITE_ASSET__DDUfRRbZ__"